import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "hidden md:block"
}
const _hoisted_2 = { class: "grid grid-cols-1 gap-2" }
const _hoisted_3 = { class: "space-y-0.5 text-sm" }
const _hoisted_4 = { class: "flex justify-between" }
const _hoisted_5 = { class: "font-bold text-black" }
const _hoisted_6 = { class: "flex justify-between" }
const _hoisted_7 = { class: "font-semibold text-black" }
const _hoisted_8 = { class: "flex justify-between" }
const _hoisted_9 = { class: "font-semibold text-black" }
const _hoisted_10 = { class: "flex justify-between" }
const _hoisted_11 = { class: "font-semibold text-black" }
const _hoisted_12 = { class: "flex justify-between items-start gap-2" }
const _hoisted_13 = {
  class: "text-black relative",
  "data-siret-tva-info": ""
}
const _hoisted_14 = {
  key: 0,
  class: "absolute -right-[260px] bottom-full mb-2 w-[300px] px-4 py-3 bg-blue-50 border border-blue-200 rounded text-sm text-black z-[99999] shadow-lg"
}
const _hoisted_15 = { class: "font-semibold text-black text-right" }
const _hoisted_16 = { class: "flex justify-between" }
const _hoisted_17 = { class: "font-semibold text-black" }
const _hoisted_18 = { class: "flex justify-between" }
const _hoisted_19 = { class: "font-semibold text-black" }
const _hoisted_20 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_21 = { class: "space-y-0.5 text-sm" }
const _hoisted_22 = { class: "flex justify-between" }
const _hoisted_23 = { class: "flex justify-between" }
const _hoisted_24 = { class: "font-semibold text-black" }
const _hoisted_25 = { class: "flex justify-between" }
const _hoisted_26 = { class: "font-semibold text-black" }
const _hoisted_27 = { class: "flex justify-between" }
const _hoisted_28 = { class: "font-semibold text-black" }
const _hoisted_29 = { class: "flex justify-between" }
const _hoisted_30 = { class: "font-semibold text-black" }
const _hoisted_31 = { class: "flex justify-between" }
const _hoisted_32 = {
  key: 1,
  class: "block md:hidden"
}
const _hoisted_33 = { class: "space-y-1.5" }
const _hoisted_34 = { class: "flex items-center justify-between" }
const _hoisted_35 = { class: "text-sm font-semibold text-black bg-white px-1.5 py-0.5 rounded border" }
const _hoisted_36 = { class: "flex items-center justify-between" }
const _hoisted_37 = { class: "text-sm text-black" }
const _hoisted_38 = { class: "flex items-start justify-between gap-2" }
const _hoisted_39 = { class: "text-sm text-black text-right leading-tight" }
const _hoisted_40 = { class: "flex items-start justify-between gap-2" }
const _hoisted_41 = { class: "text-sm text-black text-right leading-tight break-all" }
const _hoisted_42 = { class: "flex items-start justify-between gap-2" }
const _hoisted_43 = {
  class: "text-sm text-black relative",
  "data-siret-tva-info": ""
}
const _hoisted_44 = {
  key: 0,
  class: "fixed left-10 right-4 top-24 px-4 py-3 bg-blue-50 border border-blue-200 rounded text-sm text-black z-[9999] shadow-lg md:absolute md:left-auto md:-right-[120px] md:top-auto md:bottom-full md:mb-1 md:max-w-[240px]"
}
const _hoisted_45 = { class: "text-sm text-black" }
const _hoisted_46 = { class: "flex items-start justify-between gap-2" }
const _hoisted_47 = { class: "text-sm text-black text-right leading-tight break-all" }
const _hoisted_48 = { class: "flex items-center justify-between" }
const _hoisted_49 = { class: "text-sm text-black" }
const _hoisted_50 = {
  key: 0,
  class: "mt-2 pt-2 border-t border-gray-100"
}
const _hoisted_51 = { class: "space-y-1 text-sm" }
const _hoisted_52 = { class: "flex justify-between" }
const _hoisted_53 = { class: "text-black" }
const _hoisted_54 = { class: "flex justify-between" }
const _hoisted_55 = { class: "text-black" }
const _hoisted_56 = { class: "flex justify-between" }
const _hoisted_57 = { class: "text-black" }
const _hoisted_58 = { class: "flex justify-between" }
const _hoisted_59 = { class: "text-black" }
const _hoisted_60 = { class: "flex justify-between" }
const _hoisted_61 = { class: "text-black" }
const _hoisted_62 = { class: "flex justify-between" }
const _hoisted_63 = { class: "text-black" }
const _hoisted_64 = { class: "mt-2" }
const _hoisted_65 = {
  key: 2,
  class: "text-sm text-black"
}

import { computed, inject, onMounted, onUnmounted, ref, type ComputedRef } from 'vue'
import { DataCard } from '@/components'
import UploadZone from './UploadZone.vue'
import type { Address, ClientData, OrderDetailResponse } from '@/types'
import { mapToBillingAddress, mapToClientData } from '@/utils/orderMapper'
import { useAuthStore } from '@/stores/auth'

// Props
interface Props {
  orderId: number
  collapsible?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientInfo',
  props: {
    orderId: {},
    collapsible: { type: Boolean, default: false }
  },
  emits: ["invoiceUploaded", "collapsed"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

// État du collapse
const isCollapsed = ref(true)

// Mode admin (impersonation depuis le back-office EFP): on met en évidence
// le nom de la société de facturation (couleur, taille, gras).
const authStore = useAuthStore()
const isAdmin = computed(() => authStore.isImpersonating)
const showSiretTvaInfo = ref(false)

// Récupérer les données depuis le parent via inject
const orderDetailDataInjected = inject<ComputedRef<{ value: OrderDetailResponse | null }>>('orderDetailData', computed(() => ({ value: null })))

// Simplifier l'accès aux données
const orderDetailData = computed(() => orderDetailDataInjected.value.value)

// Mapper les données client
const clientData = computed<ClientData | null>(() => {
  if (!orderDetailData.value) return null
  return mapToClientData(orderDetailData.value)
})

const billingAddress = computed<Address | null>(() => {
  if (!orderDetailData.value) return null
  return mapToBillingAddress(orderDetailData.value)
})

// Méthodes
const formatDate = (date?: string): string => {
  if (!date) return '-'
  try {
    return new Date(date).toLocaleDateString('fr-FR')
  } catch {
    return date
  }
}

const handleInvoiceUploaded = (action: 'upload' | 'delete') => {
  emit('invoiceUploaded', action)
}

const toggleCollapse = () => {
  if (props.collapsible) {
    isCollapsed.value = !isCollapsed.value
    emit('collapsed', isCollapsed.value)
  }
}

const handleClickOutsideSiretInfo = (event: MouseEvent) => {
  if (!showSiretTvaInfo.value) return
  const target = event.target
  if (!(target instanceof Element)) return

  if (!target.closest('[data-siret-tva-info]')) {
    showSiretTvaInfo.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutsideSiretInfo)
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutsideSiretInfo)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DataCard), {
    title: "Informations client",
    icon: "fas fa-user",
    iconBgColor: "bg-blue-100",
    iconColor: "text-blue-600",
    clickable: false,
    className: "p-3 max-[600px]:p-4"
  }, _createSlots({
    default: _withCtx(() => [
      (clientData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", null, [
                _cache[10] || (_cache[10] = _createElementVNode("h4", { class: "font-bold text-black mb-1 text-lg" }, "Informations du client", -1)),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-black" }, "Numéro de suivi de commande:", -1)),
                    _createElementVNode("span", _hoisted_5, "#" + _toDisplayString(clientData.value.orderNumber || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-black" }, "Date de la commande:", -1)),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(formatDate(clientData.value.orderDate)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-black" }, "NOM Prénom:", -1)),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(clientData.value.fullName || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-black" }, "Email:", -1)),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(clientData.value.email || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, [
                      _cache[7] || (_cache[7] = _createTextVNode(" N° SIRET / TVA: ")),
                      _createElementVNode("button", {
                        type: "button",
                        class: "inline-flex items-center justify-center w-4 h-4 ml-1 text-[10px] font-bold text-blue-600 border border-blue-300 rounded-full hover:bg-blue-50 transition-colors align-middle",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (showSiretTvaInfo.value = !showSiretTvaInfo.value), ["stop"]))
                      }, " i "),
                      (showSiretTvaInfo.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[6] || (_cache[6] = [
                            _createElementVNode("div", { class: "space-y-1" }, [
                              _createElementVNode("p", null, [
                                _createTextVNode(" Pour le SIRET : "),
                                _createElementVNode("a", {
                                  href: "https://avis-situation-sirene.insee.fr/",
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                  class: "text-blue-600 hover:underline"
                                }, " cliquer ici pour vérifier le SIRET ")
                              ]),
                              _createElementVNode("p", null, [
                                _createTextVNode(" Pour la TVA : "),
                                _createElementVNode("a", {
                                  href: "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                  class: "text-blue-600 hover:underline"
                                }, " cliquer ici pour vérifier la TVA ")
                              ])
                            ], -1)
                          ])))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(clientData.value.siret || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-black" }, "N° EORI:", -1)),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(clientData.value.eori || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-black" }, "Mode de paiement:", -1)),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(clientData.value.paymentMethod || '-'), 1)
                  ])
                ])
              ])
            ]),
            (billingAddress.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _cache[15] || (_cache[15] = _createElementVNode("h4", { class: "font-bold text-black mb-1 text-lg" }, "Adresse de facturation", -1)),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("span", {
                        class: _normalizeClass(isAdmin.value ? 'text-red-600 font-bold text-base' : 'text-black')
                      }, "Nom de la société:", 2),
                      _createElementVNode("span", {
                        class: _normalizeClass(isAdmin.value ? 'text-red-600 font-bold text-base' : 'text-black')
                      }, _toDisplayString(billingAddress.value.enseigne || '-'), 3)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-black" }, "Adresse:", -1)),
                      _createElementVNode("span", _hoisted_24, _toDisplayString(billingAddress.value.adresse || '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-black" }, "Code postal:", -1)),
                      _createElementVNode("span", _hoisted_26, _toDisplayString(billingAddress.value.codePostal || '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _cache[13] || (_cache[13] = _createElementVNode("span", { class: "text-black" }, "Ville:", -1)),
                      _createElementVNode("span", _hoisted_28, _toDisplayString(billingAddress.value.ville || '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-black" }, "Pays:", -1)),
                      _createElementVNode("span", _hoisted_30, _toDisplayString(billingAddress.value.pays || '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("span", {
                        class: _normalizeClass(isAdmin.value ? 'text-red-600 font-bold text-base' : 'text-black')
                      }, "Téléphone:", 2),
                      _createElementVNode("span", {
                        class: _normalizeClass(isAdmin.value ? 'text-red-600 font-bold text-base' : 'text-black')
                      }, _toDisplayString(billingAddress.value.telephone || '-'), 3)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (orderDetailData.value && orderDetailData.value.id_commande)
              ? (_openBlock(), _createBlock(UploadZone, {
                  key: 1,
                  "order-id": Number(orderDetailData.value.id_commande),
                  "order-group-id": Number(orderDetailData.value.id_commande_groupe || 0),
                  "order-date": orderDetailData.value.commandeGroupe?.date_creation || new Date().toISOString(),
                  "invoice-id": orderDetailData.value.id_commande_name,
                  onInvoiceUploaded: handleInvoiceUploaded
                }, null, 8, ["order-id", "order-group-id", "order-date", "invoice-id"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (clientData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _createElementVNode("div", {
              class: _normalizeClass([
          'transition-all duration-300 ease-in-out overflow-hidden',
          _ctx.collapsible ? (isCollapsed.value ? 'max-h-0 opacity-0' : 'max-h-screen opacity-100') : ''
        ])
            }, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-sm text-black" }, "N° commande:", -1)),
                  _createElementVNode("span", _hoisted_35, "#" + _toDisplayString(clientData.value.orderNumber || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-sm text-black" }, "Date:", -1)),
                  _createElementVNode("span", _hoisted_37, _toDisplayString(formatDate(clientData.value.orderDate)), 1)
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-sm text-black flex-shrink-0" }, "Client:", -1)),
                  _createElementVNode("span", _hoisted_39, _toDisplayString(clientData.value.fullName || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-sm text-black flex-shrink-0" }, "Email:", -1)),
                  _createElementVNode("span", _hoisted_41, _toDisplayString(clientData.value.email || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("span", _hoisted_43, [
                    _cache[21] || (_cache[21] = _createTextVNode(" SIRET/TVA: ")),
                    _createElementVNode("button", {
                      type: "button",
                      class: "inline-flex items-center justify-center w-4 h-4 ml-1 text-[10px] font-bold text-blue-600 border border-blue-300 rounded-full hover:bg-blue-50 transition-colors align-middle",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (showSiretTvaInfo.value = !showSiretTvaInfo.value), ["stop"]))
                    }, " i "),
                    (showSiretTvaInfo.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, _cache[20] || (_cache[20] = [
                          _createElementVNode("div", { class: "space-y-1" }, [
                            _createElementVNode("p", null, [
                              _createTextVNode(" Pour le SIRET : "),
                              _createElementVNode("a", {
                                href: "https://avis-situation-sirene.insee.fr/",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                class: "text-blue-600 hover:underline"
                              }, " cliquer ici pour vérifier le SIRET ")
                            ]),
                            _createElementVNode("p", null, [
                              _createTextVNode(" Pour la TVA : "),
                              _createElementVNode("a", {
                                href: "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                class: "text-blue-600 hover:underline"
                              }, " cliquer ici pour vérifier la TVA ")
                            ])
                          ], -1)
                        ])))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", _hoisted_45, _toDisplayString(clientData.value.siret || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _cache[22] || (_cache[22] = _createElementVNode("span", { class: "text-sm text-black flex-shrink-0" }, "EORI:", -1)),
                  _createElementVNode("span", _hoisted_47, _toDisplayString(clientData.value.eori || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _cache[23] || (_cache[23] = _createElementVNode("span", { class: "text-sm text-black" }, "Paiement:", -1)),
                  _createElementVNode("span", _hoisted_49, _toDisplayString(clientData.value.paymentMethod || '-'), 1)
                ])
              ]),
              (billingAddress.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _cache[30] || (_cache[30] = _createElementVNode("h4", { class: "font-medium text-black mb-1 text-sm" }, "Adresse de facturation", -1)),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _cache[24] || (_cache[24] = _createElementVNode("span", { class: "text-black" }, "Société:", -1)),
                        _createElementVNode("span", _hoisted_53, _toDisplayString(billingAddress.value.enseigne || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _cache[25] || (_cache[25] = _createElementVNode("span", { class: "text-black" }, "Adresse:", -1)),
                        _createElementVNode("span", _hoisted_55, _toDisplayString(billingAddress.value.adresse || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_56, [
                        _cache[26] || (_cache[26] = _createElementVNode("span", { class: "text-black" }, "Code postal:", -1)),
                        _createElementVNode("span", _hoisted_57, _toDisplayString(billingAddress.value.codePostal || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _cache[27] || (_cache[27] = _createElementVNode("span", { class: "text-black" }, "Ville:", -1)),
                        _createElementVNode("span", _hoisted_59, _toDisplayString(billingAddress.value.ville || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        _cache[28] || (_cache[28] = _createElementVNode("span", { class: "text-black" }, "Pays:", -1)),
                        _createElementVNode("span", _hoisted_61, _toDisplayString(billingAddress.value.pays || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _cache[29] || (_cache[29] = _createElementVNode("span", { class: "text-black" }, "Téléphone:", -1)),
                        _createElementVNode("span", _hoisted_63, _toDisplayString(billingAddress.value.telephone || '-'), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_64, [
                (orderDetailData.value && orderDetailData.value.id_commande)
                  ? (_openBlock(), _createBlock(UploadZone, {
                      key: 0,
                      "order-id": Number(orderDetailData.value.id_commande),
                      "order-group-id": Number(orderDetailData.value.id_commande_groupe || 0),
                      "order-date": orderDetailData.value.commandeGroupe?.date_creation || new Date().toISOString(),
                      "invoice-id": orderDetailData.value.id_commande_name,
                      onInvoiceUploaded: handleInvoiceUploaded
                    }, null, 8, ["order-id", "order-group-id", "order-date", "invoice-id"]))
                  : _createCommentVNode("", true)
              ])
            ], 2)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_65, " Chargement des données... "))
    ]),
    _: 2
  }, [
    (_ctx.collapsible)
      ? {
          name: "header-toggle",
          fn: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "text-black md:hidden",
              onClick: _withModifiers(toggleCollapse, ["stop"])
            }, [
              _createElementVNode("i", {
                class: _normalizeClass([
            'fas transition-transform duration-200',
            isCollapsed.value ? 'fa-chevron-down' : 'fa-chevron-up'
          ])
              }, null, 2)
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1024))
}
}

})